// extracted by mini-css-extract-plugin
module.exports = {"loader_position":"measurementLoader_loader_position__3zfl9","loader_text":"measurementLoader_loader_text__lxS8H","loader_gif":"measurementLoader_loader_gif__25y5t"};